import {
    Alert,
    Box,
    Container,
    Flex,
    Grid,
    Paper,
    SimpleGrid,
    Text,
} from "@mantine/core";
import { useSession } from "next-auth/react";
import { useEffect } from "react";
import { useState } from "react";
import {
    compute_ASM_data,
    extract_data_value,
    getLineChartData,
    getOverallAccuracyData,
    getOverallMarksData,
    getOverallSpeedData,
} from "../common/commonfunc";

import AnalyticsCalendarHeatmapChart from "./AnalyticsCalendarHeatmapChart";
import AnalyticsLineChart from "./AnalyticsLineChart";
import LoginAlert from "./LoginAlert";
import TestAnalyticsAccuracy from "./TestAnalyticsAccuracy";
import TestAnalyticsMarks from "./TestAnalyticsMarks";
import TestAnalyticsRankings from "./TestAnalyticsRankings";
import TestAnalyticsSpeed from "./TestAnalyticsSpeed";
import { TestAttemptsTable } from "./TestAttemptsTable";

const TestAnalyticsUI = ({}) => {
    const { data: session, status } = useSession();
    const [userID, setUserID] = useState(null);
    const [userAnalytics, setUserAnalytics] = useState({});
    let minDistictTestRequired = 3;

    const {
        lineChartData = null,
        countDistinctTests = minDistictTestRequired,
        userRank = null,
        current_user_marks = null,
        all_user_marks_avg = null,
        current_user_accuracy = null,
        all_user_accuracy_avg = null,
        current_user_speed = null,
        all_user_speed_avg = null,
        current_user_attempts_table = null,
        dataHeatMapCalendar = null,
    } = userAnalytics;

    // console.log({ current_user_marks, all_user_marks_avg });

    // on loading this page run the fetch once
    // useEffect(() => {
    //     if (!!session && !!session.info) {
    //     } else {
    //         setUserID(null);
    //         console.log("null");
    //     }
    // }, [session]);
    useEffect(() => {
        if (status == "authenticated") {
            setUserID(session.info.id);
        } else {
            setUserID(null);
        }
    }, [status, session]);

    useEffect(() => {
        console.log({ userID });
        if (!!userID)
            fetch(`/api/performance/${userID}`)
                .then((res) => res.json())
                .then((resp) => {
                    console.log({ resp });
                    setUserAnalytics(resp);
                });
    }, [userID]);

    console.log({ userID });

    console.log({ lineChartData });

    return (
        <Container>
            {!!!session && (
                <Box my={10}>
                    <LoginAlert />
                </Box>
            )}
            <Paper p={10} m={10} withBorder>
                <Text ta={"center"} fw={"bold"} fz={"xl"}>
                    Compare Your Performance with Toppers!
                </Text>
                <Flex style={{ height: "300px", minWidth: 0 }}>
                    {countDistinctTests >= minDistictTestRequired && (
                        <AnalyticsLineChart data={lineChartData} />
                    )}
                    {countDistinctTests < minDistictTestRequired && (
                        <Text
                            py={30}
                            w={"100%"}
                            c="dimmed"
                            ta={"center"}
                            fw={"bold"}
                            fz={"lg"}
                            sx={(theme) => ({
                                border:
                                    theme.colorScheme == "dark"
                                        ? `5px dashed ${theme.colors.dark[6]}`
                                        : `5px dashed ${theme.colors.gray[2]}`,
                                borderRadius: theme.radius.md,
                            })}
                        >
                            You&apos;ve given only {countDistinctTests} tests
                            till now.
                            <br />
                            You need to give atleast {
                                minDistictTestRequired
                            }{" "}
                            tests to compare your performance with toppers.
                        </Text>
                    )}
                </Flex>
            </Paper>
            <Grid grow>
                {/* <Flex>Legendary Eagle rank</Flex> */}
                <Grid.Col xs={12} sm={6} md={3}>
                    <TestAnalyticsRankings number={userRank} />
                </Grid.Col>
                <Grid.Col xs={12} sm={6} md={3}>
                    <TestAnalyticsAccuracy
                        number={current_user_accuracy}
                        other={all_user_accuracy_avg}
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6} md={3}>
                    <TestAnalyticsSpeed
                        number={current_user_speed}
                        other={all_user_speed_avg}
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6} md={3}>
                    <TestAnalyticsMarks
                        number={current_user_marks}
                        other={all_user_marks_avg}
                    />
                </Grid.Col>
            </Grid>
            <AnalyticsCalendarHeatmapChart data={dataHeatMapCalendar} />

            <Paper p={10} m={10} withBorder>
                <Text ta={"center"} fw={"bold"} fz={"xl"}>
                    Assess Attempts, Unlock Solutions!
                </Text>
                <TestAttemptsTable
                    current_analytics={current_user_attempts_table}
                />
            </Paper>
        </Container>
    );
};

export default TestAnalyticsUI;
